import { type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { type BaseChartProps } from "./chart-helpers";

interface ChartWrapperProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  height?: number | string;
  width?: number | string;
}

export function ChartWrapper({
  children,
  title,
  subtitle,
  className,
  height = 300,
  width = "100%",
}: ChartWrapperProps) {
  return (
    <div className={cn("flex w-full flex-col", className)}>
      {(title || subtitle) && (
        <div className="mb-4 text-center">
          {title && <h3 className="text-xl font-medium">{title}</h3>}
          {subtitle && (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
      )}
      <div
        style={{
          height: typeof height === "number" ? `${height}px` : height,
          width: typeof width === "number" ? `${width}px` : width,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export type { BaseChartProps };
